// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1TSHn","container":"styles_container__242Lr","title":"styles_title__1FLgO","wrapper":"styles_wrapper__3YFUu","answer":"styles_answer__3MmgT"};